const SLUG_PATTERN = /^[a-z0-9-]+$/;

const clientDashboardGuard = (to, from, next) => {
  const { clientSlug } = to.params;

  if (SLUG_PATTERN.test(clientSlug)) {
    next();
    return;
  }

  next({ name: 'landing-page' });
};

export default clientDashboardGuard;
